import { shape, string } from "prop-types";

export default {
  id: string.isRequired,
  attachment: string,
  body: string,
  raw: string,
  from: shape({
    email: string,
    fname: string,
    lname: string,
  }).isRequired,
  sentAt: string.isRequired,
  subject: string.isRequired,
};
